import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { AnimationOption } from '../../../common/models';

const DESKTOP_POST_COUNT = 12;
const MOBILE_POST_COUNT = 3;
const MOBILE_VIEWPORT_QUERY = '(max-width: 639px)';

@Component({
  selector: 'lib-social-wall-widget',
  templateUrl: './social-wall-widget.component.html',
  styleUrl: './social-wall-widget.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SocialWallWidgetComponent {

  public channelId = input<string | null>(null);
  public defaultChannelId = input<string | null>(null);
  public animation = input<AnimationOption>();
  public animationDelay = input(0);

  public seeAllPosts = output<void>();

  private readonly breakpointObserver = inject(BreakpointObserver);

  private readonly isMobileViewport = toSignal(
    this.breakpointObserver.observe(MOBILE_VIEWPORT_QUERY).pipe(map(result => result.matches)),
    { initialValue: this.breakpointObserver.isMatched(MOBILE_VIEWPORT_QUERY) }
  );

  public postCount = computed(() => this.isMobileViewport() ? MOBILE_POST_COUNT : DESKTOP_POST_COUNT);

}
